import React from 'react'
import { Route, Trip } from 'data/records'
import { Trip as TripV2 } from 'lib/api/records'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import { errorMessage } from 'lib/styleguide/base.scss'
import { commonNouns } from 'lib/localization'
import PropTypes from 'prop-types'
import { FormattedMessage as T, injectIntl, defineMessages } from 'react-intl'
import _ from 'lodash'

export const DELETE_TROUTE_DIALOG = 'DELETE_TROUTE_DIALOG'
export const DELETE_TROUTES_DIALOG = 'DELETE_TROUTES_DIALOG'

const trouteType = PropTypes.oneOfType([
  PropTypes.instanceOf(Route),
  PropTypes.instanceOf(Trip),
  PropTypes.instanceOf(TripV2)
])

const messages = defineMessages({
  confirmText: {
    id: 'DeleteTRoute.confirmText',
    defaultMessage: 'Permanently Delete {str}'
  },
  objects: {
    id: 'DeleteTRoute.objects',
    defaultMessage: '{count, plural, one {object} other {objects}}'
  },
  title: {
    id: 'DeleteTRoute.title',
    defaultMessage: 'Delete {str}?',
    values: str => <strong>{...str}</strong>
  },
  trouteError: {
    id: 'DeleteTRoute.trouteError',
    defaultMessage: 'Oops, we encountered an error while deleting this {typeStr}. Please try again.'
  },
  troutesError: {
    id: 'DeleteTRoute.troutesError',
    defaultMessage: 'Oops, we encountered an error while deleting these {typeStr}. Please try again.'
  }
})

class DeleteDialog extends React.PureComponent {
  static propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    confirmMessage: PropTypes.any.isRequired,
    confirmText: PropTypes.any.isRequired,
    deleteErrorMessage: PropTypes.any.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      deletePending: false,
      deleteError: false
    }
  }

  onConfirm = () => {
    const { onConfirm, onRequestClose } = this.props

    this.setState({ deletePending: true })
    onConfirm()
      .then(onRequestClose)
      .catch(() => this.setState({ deletePending: false, deleteError: true }))
  }

  render () {
    const {
      onRequestClose,
      confirmMessage,
      deleteErrorMessage,
      confirmText,
      title
    } = this.props
    const {
      deletePending,
      deleteError
    } = this.state

    return (
      <ConfirmationDialog
        primary danger
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={this.onConfirm}
        confirmPending={deletePending}
        confirmText={confirmText}
        title={title}>
        {confirmMessage}
        {deleteError && <div className={errorMessage}>
          {deleteErrorMessage}
        </div>}
      </ConfirmationDialog>
    )
  }
}

class _DeleteTRoute extends React.PureComponent {
  static propTypes = {
    troute: trouteType.isRequired
  }

  render () {
    const { troute, intl, ...props } = this.props

    const typeStr = _.capitalize(intl.formatMessage(troute instanceof Route ? commonNouns.routes : commonNouns.trips, { count: 1 }))

    return <DeleteDialog
      title={intl.formatMessage(messages.title, { str: typeStr })}
      confirmText={intl.formatMessage(messages.confirmText, { str: typeStr })}
      confirmMessage={<p>
        <T id='DeleteTRoute.trouteConfirmMessage'
          defaultMessage='Are you sure you want to delete your {typeStr}, {name}? {br} This action cannot be undone.'
          values={{
            typeStr,
            name: <strong>{troute.name}</strong>,
            br: <br />
          }} />
      </p>}
      deleteErrorMessage={intl.formatMessage(messages.trouteError, { typeStr })}
      {...props} />
  }
}

export const DeleteTRoute = injectIntl(_DeleteTRoute)

class _DeleteTRoutes extends React.PureComponent {
  static propTypes = {
    troutes: PropTypes.oneOfType([
      PropTypes.array,
      trouteType
    ]).isRequired
  }

  render () {
    const { troutes, intl, ...props } = this.props

    if (Array.isArray(troutes) && troutes.length > 1) {
      const typeMsg = troutes.length >= 1
        ? (troutes[0] instanceof Route ? commonNouns.routes : commonNouns.trips)
        : messages.objects
      const typeStr = _.capitalize(intl.formatMessage(typeMsg, { count: troutes.length }))
      const deleteStr = `${troutes.length} ${typeStr}`

      return (<DeleteDialog
        title={intl.formatMessage(messages.title, { str: deleteStr })}
        confirmMessage={<p>
          <T id='DeleteTRoute.troutesConfirmMessage'
            defaultMessage='Are you sure you want to delete {deleteStr}? {br} This action cannot be undone.'
            values={{
              deleteStr: <strong>{deleteStr}</strong>,
              br: <br />
            }} />
        </p>}
        confirmText={intl.formatMessage(messages.confirmText, { str: deleteStr })}
        deleteErrorMessage={intl.formatMessage(messages.troutesError, { typeStr: intl.formatMessage(typeMsg, { count: 0 }) })}
        {...props}
      />)
    } else {
      const troute = Array.isArray(troutes) ? troutes[0] : troutes
      return <DeleteTRoute troute={troute} {...props} />
    }
  }
}

export const DeleteTRoutes = injectIntl(_DeleteTRoutes)
